import { OwcIcon, OwcButton, OwcChip, OwcSelectDropdown, OwcListItem } from '@one/react';
import { useNavigate } from 'react-router-dom';
import './FiltersPanel.css';
import { useGroupData } from '../../../../contexts/GroupDataContext';
import { isLatestOnlyGroup } from '../../../../utils/getDataGroupPath';

function FiltersPanel({
  schemaData,
  schemaSource,
  entityVersions = [],
  entityVersionsLoading = false,
  selectedEntityVersion = '',
  onEntityVersionChange,
}) {
  const { groupData, releaseVersion } = useGroupData();
  const navigate = useNavigate();
  const latestOnly = isLatestOnlyGroup(groupData?.groupName);
  const latestEntityVersion = entityVersions[0];
  const showVersionDropdown =
    latestOnly && schemaData?.name && (entityVersionsLoading || entityVersions.length > 0);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
        }}
      >
        <div>
          {schemaData?.name && (
            <div
              style={{
                marginBottom: 1,
                fontSize: '24px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              {schemaData?.name && (
                <span
                  style={{
                    maxWidth: '400px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                  }}
                  title={schemaData?.name}
                >
                  {schemaData?.name}
                </span>
              )}

              {releaseVersion && !isLatestOnlyGroup(groupData?.groupName) && (
                <OwcChip
                  disableRipple
                  style={{ background: 'var(--one-color-subbrand-200)', cursor: 'auto' }}
                >
                  {releaseVersion}
                </OwcChip>
              )}

              {schemaSource?.type && (
                <OwcChip
                  disableRipple
                  style={{ background: 'var(--one-color-subbrand-200)', cursor: 'auto' }}
                >
                  {schemaSource.type?.charAt(0).toUpperCase() + schemaSource.type?.slice(1)}
                </OwcChip>
              )}
            </div>
          )}
        </div>
      </div>
      <div style={{ display: 'flex' }}>
        {showVersionDropdown && (
          <OwcSelectDropdown
            size="small"
            label="Version"
            placeholder={entityVersionsLoading ? 'Loading versions...' : 'Version'}
            value={selectedEntityVersion || latestEntityVersion || ''}
            onValueChange={onEntityVersionChange}
            disabled={entityVersionsLoading || entityVersions.length === 0}
            no-clear-icon
            variant="outlined"
            style={{ width: '100px', paddingRight: '20px' }}
            aria-label="Schema version"
          >
            {entityVersions.map((version) => (
              <OwcListItem key={version} value={version}>
                {version === latestEntityVersion ? `${version}` : version}
              </OwcListItem>
            ))}
          </OwcSelectDropdown>
        )}
        {schemaData?.name && (
          <OwcButton
            variant="primary"
            size="medium"
            onClick={() =>
              navigate('/dashboard/SchemaComparison', {
                state: {
                  schemaSelection: {
                    type: schemaSource?.type,
                    name: schemaSource?.name,
                    parent: schemaSource?.parent || '',
                  },
                },
              })
            }
          >
            <OwcIcon name="compare_arrows" family="outlined" slot="prefix" />
            Compare Schema
          </OwcButton>
        )}
      </div>
    </div>
  );
}

export default FiltersPanel;
